export const SHARE_TYPES = {
  NONE: 'Не установлено',
  PRIVATE: 'Частная собственность',
  COMMUNAL: 'Коммунальная собственность',
  STATE: 'Государственная собственность',
};
